<template>
<div class="bounty-leaderboard">
    <!-- <table> keeps overflowing the tippy... use css grid instead -->
    <div v-if="hasBounties" class="bounty-grid">
        <span></span>
        <span class="bounty-header">Name</span>
        <span class="bounty-header bounty-amount">Bits</span>
        <template v-for="(bounty, i) in displayedBounties">
            <span
                class="bounty-rank"
                :key="`${bounty.userId}rank`">
                {{ i + 1 }}
            </span>
            <UserProfile :user="toUserObject(bounty)" :key="bounty.userId"/>
            <div class="bounty-amount" :key="`${bounty.userId}amount`">
                {{ bounty.totalAmount.toLocaleString() }}
            </div>
        </template>
    </div>
    <div class="has-text-centered">
        <a v-if="numHiddenBounties > 0" @click="showAll = true">
            View All
        </a>
    </div>
    <div class="bounty-actions">
        <slot></slot>
    </div>
</div>
</template>

<script>
import UserProfile from '@/components/UserProfile'

export default {
    name: 'BountyLeaderboard',
    props: {
        suggestion: Object,
    },
    data: () => ({
        showAll: false,
    }),
    computed: {
        bounties: vm => vm.suggestion.bounties,
        displayedBounties: vm => {
            const num = vm.showAll ? vm.bounties.length : 3
            return vm.bounties.slice(0, num)
        },
        numHiddenBounties: vm => vm.bounties.length - vm.displayedBounties.length,
        totalAmount: vm => vm.bounties.reduce((memo, b) => b.totalAmount + memo, 0),
        hasBounties: vm => vm.totalAmount > 0,
    },
    methods: {
        toUserObject: bounty => ({
            ...bounty,
            name: bounty.displayName,
            id: bounty.userId,
        })
    },
    components: {
        UserProfile,
    }
}
</script>

<style lang="scss" scoped>
.bounty-leaderboard {
    .bounty-grid {
        display: grid;
        grid-template-rows: auto;
        grid-template-columns: auto 1fr auto;
        grid-gap: 0.5rem;
        align-items: center;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 8px;
        max-height: 230px;

        .bounty-header {
            font-size: 0.7rem;
        }
        .bounty-amount, .bounty-rank {
            text-align: right;
        }
    }
    .bounty-actions {
        text-align: center;
        border-top: 1px solid $border-color;
        padding: 4px;
    }
}
</style>
